import { AfterViewInit, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddbranchComponent } from '../addbranch/addbranch.component';
@Component({
  selector: 'app-branchview',
  templateUrl: './branchview.component.html',
  styleUrls: ['./branchview.component.css']
})
export class BranchviewComponent implements OnInit  {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  branchBO: any = [];
  branchColl: any = [];
  branchid: number = 0

  receiptsettingsColl: any = [];
  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  branchform = new FormGroup({
    branchid: new FormControl(0),
    branchname: new FormControl('', Validators.required),
    branchcode: new FormControl('', Validators.required),
    address: new FormControl(''),
    country: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl(''),
    website: new FormControl(''),
    taxregnum: new FormControl(''),
    state: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Branch";

  editformtype: string = "";



  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,public router: Router,  private productFindService: NgbModal, 
    private loginService: LoginDataService,  private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.branchid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.branchform.reset();
      this.fnInitializebranch();

      if (this.branchid > 0) {
        this.fngetBranch();
      }
      this.fngetCountries();
      this.fngetState();
      this.fngetReceiptSettings();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.branchid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializebranch() {
    this.branchform.setValue({

      branchid: 0,
      branchname: '',
      branchcode: '',
      address: '',
      country: '',
      phone: '',
      email: '',
      website: '',
      taxregnum: '',
      state: '',
      inactive:false,
    })
  }
  fngetReceiptSettings() {
    var data = {
      
      'branchid': this.branchid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getReceiptSettings(data)
      .subscribe(
        (res) => {
          //console.log(res)
          this.receiptsettingsColl = res.json().result;
//console.log(this.receiptsettingsColl)

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetCountries() {

    this.appService.getCountries().subscribe((res) => {
      this.countryColl = res.json();

    })
  }

  fngetState() {

      var country =this.branchform.get('country').value
   
      this.stateColl = []

    this.appService.getState(country).subscribe((res) => {
      this.stateColl = res.json();
      //console.log(this.stateColl)

    })
  }
  //Get 
  fngetBranch() {
    var data = {
      'branchid': this.branchid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          this.branchColl = res.json().result;
          var editdata = this.branchColl[0];
          this.branchBO = editdata
          //console.log(this.branchBO)
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.branchform.valid) {
        //Check
        var data = {
          'branchid': this.branchid,
          'branchname': this.branchform.get('branchname').value,
          'branchcode': this.branchform.get('branchcode').value,
          'address': this.branchform.get('address').value,
          'country': this.branchform.get('country').value,
          'state': this.branchform.get('state').value,
          'phone': this.branchform.get('phone').value,
          'email': this.branchform.get('email').value,
          'website': this.branchform.get('website').value,
          'taxregnum': this.branchform.get('taxregnum').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.branchform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
        this.appService.fnCheckBranch(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.branchform.get('branchid').value > 0) {
                //Update Department
                this.fnSetBranch(data);
              }
              else {
                //Insert Department
                this.fnInsertBranch(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.branchform.controls['branchname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertBranch(data) {

    this.appService.fnInsertBranch(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The new Branch has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.branchid);

         
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetBranch(data) {

    this.appService.fnSetBranch(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The Branch has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.branchid, data.branchname);

         
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
  fnSaveReceiptSettings() {

    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      for (let row of this.receiptsettingsColl) {

        var data = {
          'receiptsettingsid': row.receiptsettingsid,
          'branchid': row.branchid,
          'recbranchname': row.recbranchname,
          'recaddress1': row.recaddress1,
          'recaddress2': row.recaddress2,
          'recaddress3': row.recaddress3,
          'recaddress4': row.recaddress4,
          'recaddress5': row.recaddress5,
          'rectitle': row.rectitle,
          'recgreetingtxt1': row.recgreetingtxt1,
          'recgreetingtxt2': row.recgreetingtxt2,
          'recbootertxt1': row.recbootertxt1,
          'recbootertxt2': row.recbootertxt2,
          'recbootertxt3': row.recbootertxt3,
          'recpromotxt1': row.recpromotxt1,
          'recpromotxt2': row.recpromotxt2,
          'recpromotxt3': row.recpromotxt3,
          'inactive': row.inactive,
          'companyid': this.loginService.fnGetCompanyId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        // if (!row.transcodeid) {

        //   this.fnInsertTranscode(data);

        // }
         if (row.receiptsettingsid > 0) {

          this.fnSetReceiptSettings(data);
        }

      }

      this.fnCloseForm();


      (err) => {
        this.toastr.error('Error', err);
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  // fnInsertTranscode(data) {



  //   this.appService.fnInsertTranscode(data).subscribe(
  //     (res) => {
  //       if (res.json().result != "") {
  //         //this.toastr.success('', "The new Transcode has been added successfully.Insert Successfully");

  //         this.fnInsertActivityLog('INSERT', 0, data.transcodeid);


  //       }
  //     },
  //     (err) => {
  //       this.toastr.error('Error', err);
  //     });

  // }

  //Set
  fnSetReceiptSettings(data) {

    this.appService.fnSetReceiptSettings(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          //this.toastr.success('', "The Transcode has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.branchid, data.branchname);


        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnEditBranch() {
  
    try {
    
      var deptid = this.branchid
    
      const modalRef = this.productFindService.open(AddbranchComponent, { size: <any>'l', backdrop: 'static' });
      modalRef.componentInstance.branchid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetBranch();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {

    this.branchform.setValue({

      branchid: deptBO.branchid,
      branchname: deptBO.branchname,
      branchcode: deptBO.branchcode,
      address: deptBO.address,
      country: deptBO.country,
      state: deptBO.state,
      phone: deptBO.phone,
      email: deptBO.email,
      website: deptBO.website,
      taxregnum: deptBO.taxregnum,
      inactive: deptBO.inactive,
    });

    this.fngetState();
    this.fngetCountries();
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
  }

  fnTabHeaderClick(type) {

    this.editformtype = type;

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      //  this.appService.fnInsertActivity(data).subscribe(
      //    (res)=>{
      //    },
      //    (err)=>{

      //    });

    } catch {

    }
  }


  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Branch']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
